module.exports = __webpack_public_path__ + "assets/img/TLXD-6.e8c44d5e.jpg";